<template>
  <div class="settings-tab">
    <v-container fluid fill-height>
      <v-layout column fluid justify-center>
        <v-flex xs6>
          <v-layout fluid justify-center wrap class="settings-fields">
            <v-flex xs7>
              <v-text-field v-model="stTokenEditable" label="ScanTrust token"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout fluid justify-end>
            <v-flex xs2>
              <v-btn flat color="blue" @click="save">save</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash"
import { mapGetters } from "vuex"

import { getSTUserProfile } from '@/services/AuthService'

export default {
  name: "SettingsTab",
  components: {},
  data() {
    return {
      stTokenEditable: ""
    }
  },
  methods: {
    save() {
      this.$store.dispatch("settings/setSettings", { stToken: this.stTokenEditable })
    }
  },
  computed: {
    ...mapGetters("settings", ["stToken"])
  },
  watch: {
    stToken:{
      immediate: true,
      handler(val) {
        this.stTokenEditable = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-tab{
  position: relative;
  padding: 0px;
  background: white;
}

.settings-fields{
  min-height: 300px;
}
</style>
